var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:_vm.buttonClass,on:{"click":_vm.onSubmitPayment}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }